import React, { useState } from 'react';
import ReactGA from 'react-ga4';
import styles from "./ScoreExplain.module.css";
import Image from 'next/image';
import { useIsShowScoreExplanation, useScoreExplanationposition } from '@/app/context/StateProvider';
export const ScoreExplain: React.FC = () => {
  const [isShowScoreExplanation, setIsShowScoreExplanation] = useIsShowScoreExplanation();
  const [scoreExplanationPosition, setScoreExplanationPosition] = useScoreExplanationposition();

  //This function is used to show the modal to explain the scoring system
  const showModal = (event: React.MouseEvent<HTMLParagraphElement>) => {
    event.stopPropagation();
    setScoreExplanationPosition({
      top: event.clientY,
      left: event.clientX
    });
    setIsShowScoreExplanation(true);
    ReactGA.event({
      category: 'Button Click',
      action: 'showModal'
    });
  };
  const hideModal = () => {
    setIsShowScoreExplanation(false);
  };
  return <div className={styles.scoreExplain} onMouseEnter={showModal} onMouseLeave={hideModal} data-sentry-component="ScoreExplain" data-sentry-source-file="ScoreExplain.tsx">
            <p className={styles.scoreExplainText}>Favorability</p>
            <div className={styles.info}>
                <Image src="/assets/info.svg" alt="svg" width={16} height={16} data-sentry-element="Image" data-sentry-source-file="ScoreExplain.tsx" />
            </div>
        </div>;
};